import { InlineBanner } from "components/ui/inline-banner";
import { defaultLinkStyle } from "components/ui/link";
import { useGetSmtpCredentialForUserQuery } from "generated/graphql";
import React from "react";
import { Link } from "react-router-dom";
import { useFeature } from "store/selectors/hooks";
import { stableQueryOptions } from "util/requests";

export const SmtpMissingWarningBanner: React.FC = () => {
    const featureEnabled = useFeature("smtpMissingWarning");
    const smtpQuery = useGetSmtpCredentialForUserQuery({}, stableQueryOptions());

    if (!featureEnabled) {
        return null;
    }

    if (!smtpQuery.data) {
        return null;
    }

    if (smtpQuery.data.getSmtpCredentialForUser) {
        return null;
    }

    return (
        <InlineBanner type="info">
            Our Email Send integration ensures the most reliable email delivery.{" "}
            <Link className={defaultLinkStyle} to="/settings/account/email">
                Set it up today
            </Link>{" "}
            to make your email sending even better.
        </InlineBanner>
    );
};
